//  import React from "react";
// import { Row, Col } from "react-bootstrap";
// import myshop from "../../assets/image/ac.jpeg";

// const services = [
//   {
//     id: 1,
//     title: "Web Development",
//     description:
//       "We create modern websites. We create modern websites. We create modern websites...",
//     image: myshop,
//   },
//   {
//     id: 2,
//     title: "Mobile App Development",
//     description: "Build mobile apps for iOS & Android.",
//     image: myshop,
//   },
//   {
//     id: 3,
//     title: "SEO Optimization",
//     description: "Improve search engine ranking.",
//     image: myshop,
//   },
//   {
//     id: 4,
//     title: "SEO",
//     description: "Improve search engine ranking.",
//     image: myshop,
//   },
//   {
//     id: 5,
//     title: "Optimization",
//     description: "Improve search engine ranking.",
//     image: myshop,
//   },
//   {
//     id: 6,
//     title: "Ac Services",
//     description: "Improve search engine ranking.",
//     image: myshop,
//   },
// ];

// const Services = () => {
//   return (
//     <div id="services-section">
//       <div className="mt-5 container-fluid px-md-5">
//         <div id="services-header">
//           <h2 className="text-primary text-start mb-4">Our Services</h2>
//         </div>
//         <Row className="justify-content-center">
//           {services.map((service) => (
//             <Col md={4} key={service.id} className="mb-4">
//               <div className="service-card">
//                 <div className="image-container">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className="card-img object-fit-cover"
//                     style={{ width: "100%", height: "300px" }}
//                   />
//                 </div>
//                 <div className="card-content">
//                   <h3 className="text-primary">{service.title}</h3>
//                   <p>{service.description}</p>
//                 </div>
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </div>
//     </div>
//   );
// };

// export default Services;

import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import myshop from "../../assets/image/hvacac.jpg";
import myshop1 from "../../assets/image/AC5.jpg";
import myshop2 from "../../assets/image/Hero2.jpg";
import "../../index.css";
import Testimonial from "../../Herosection/Components/Testimonials";
import Cards from "../../Herosection/Components/Cards";
import About from "../About/About";
import OtherPageTopBanner from "../../Herosection/Components/OtherPageTopBanner";

const services = [
  {
    id: 1,
    title: "HVAC Design & Consultancy Services",
    description: "Heat load calculation, layout planning, AC tonnage design, piping & electrical mapping — everything engineered for efficiency..",
    image: myshop,
  },
  {
    id: 2,
    title: "AC Supply & Installation Services",
    description: "Get branded Air Conditioners delivered and professionally installed with complete ducting, copper piping, cabling & drainage setup..",
    image: myshop1,
  },
  {
    id: 3,
    title: "Maintenance & After-Sales Support",
    description: "Ensure long-lasting performance of your air conditioning systems with our routine maintenance, repairs, and priority customer support — because your comfort is our commitment..",
    image: myshop2,
  },
];

// const Services = () => {
//   return (
//     <>
//       <div className="mt-3">
//         <About />
//       </div>

//       <div id="services-section">
//         <div className="mt-2 container-fluid px-md-5">
//           <div id="services-header">
//             <h2 className="text-primary text-start mb-4">Our Services</h2>
//           </div>
//           <Row className="justify-content-center">
//             {services.map((service) => (
//               <Col
//                 md={4}
//                 key={service.id}
//                 className="mb-4"
//                 data-aos="flip-left"
//                 data-aos-once="false"
//               >
//                 <Link
//                   to={`/service/${service.id}`}
//                   style={{ textDecoration: "none", color: "inherit" }}
//                 >
//                   <div className="service-card">
//                     <div className="image-container">
//                       <img
//                         src={service.image}
//                         alt={service.title}
//                         className="card-img object-fit-cover"
//                         style={{ width: "100%", height: "300px" }}
//                       />
//                     </div>
//                     <div className="card-content">
//                       <h3 className="text-primary">{service.title}</h3>
//                       <p>{service.description}</p>
//                     </div>
//                   </div>
//                 </Link>
//               </Col>
//             ))}
//           </Row>
//         </div>
//       </div>

//       <div className="mb-5">
//         <Cards />
//       </div>

//       <div className="mb-5">
//         <Testimonial />
//       </div>
//     </>
//   );
// };


// Pages/Services/Service.jsx

const Services = ({ showExtras = true }) => {
  return (
    <>

{/* <OtherPageTopBanner title="Our Services" /> */}


      {showExtras && (
        <>
          <div className="mt-3">
            <About />
          </div>
        </>
      )}

      <div id="services-section">
         <div className="mt-2 container-fluid px-md-5">
           <div id="services-header">
             <h2 className="text-primary text-start mb-4">Our Services</h2>
           </div>
           <Row className="justify-content-center">
             {services.map((service) => (
               <Col
                 md={4}
                 key={service.id}
                 className="mb-4"
                 data-aos="flip-left"
                 data-aos-once="false"
               >
                 <Link
                   to={`/service/${service.id}`}
                   style={{ textDecoration: "none", color: "inherit" }}
                 >
                   <div className="service-card">
                     <div className="image-container">
                       <img
                         src={service.image}
                         alt={service.title}
                         className="card-img object-fit-cover"
                         style={{ width: "100%", height: "300px" }}
                       />
                     </div>
                     <div className="card-content">
                       <h3 className="text-primary">{service.title}</h3>
                       <p>{service.description}</p>
                     </div>
                   </div>
                 </Link>
               </Col>
             ))}
           </Row>
         </div>
       </div>

      {showExtras && (
        <>
          <div className="mb-5">
            <Cards />
          </div>
          {/* <div className="mb-5">
            <Testimonial />
          </div> */}
        </>
      )}
    </>
  );
};


export default Services;
